import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/markLine'
import 'echarts/lib/component/markPoint'
import 'echarts/lib/component/dataZoom'

// Renders an ECharts option offscreen and returns a base64 PNG string
export default function renderChartToBase64(option, width = 600, height = 370) {
  // Hidden off-screen container
  const container = document.createElement('div')
  container.style.cssText = `position:absolute;left:-9999px;top:0;width:${width}px;height:${height}px;visibility:hidden;`
  document.body.appendChild(container)
  try {
    const instance = echarts.init(container, null, { width, height })
    instance.setOption({ ...option, animation: false }) // animation:false for quick render
    const dataURL = instance.getDataURL({ type: 'png', pixelRatio: 2, backgroundColor: '#fff' })
    instance.dispose()
    return dataURL
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[offscreenRender] Failed to render chart:', e)
    return null
  } finally {
    if (document.body.contains(container)) {
      document.body.removeChild(container)
    }
  }
}
